module.exports = __webpack_public_path__ + "static/media/chief-cover-Tablet.7c328815.png";